import queryString from 'query-string';

export interface UrlParamsReturn {
  prefilled?: string;
}

/* A custom hook that builds on useLocation to parse
 the query string */
export default function useUrlGetParams(): UrlParamsReturn {
  const location = window.location;
  const url = location.search;
  const params = queryString.parse(url);
  return params;
}
